import BonusDescriptionPanel from './BonusDescriptionPanel';

export default BonusDescriptionPanel;
